/**
 * Mapa de nomes de cor para valores CSS (hex).
 * Usado como fallback quando o swatch não vem configurado no admin.
 */
(function () {
  'use strict';

  var COLOR_MAP = {
    'azul marinho': '#31425a',
    'branco': '#ffffff',
    'cinza': '#707073',
    'preto': '#000000',
    'bordô': '#803141',
    'bordo': '#803141',
    'salmão': '#f4e0dd',
    'salmao': '#f4e0dd',
    'verde sálvia': '#5e7572',
    'verde salvia': '#5e7572',
    'verde especial': '#414938',
    'verde-especial': '#414938',
    'off white': '#f3f2ee',
    'off-white': '#f3f2ee',
    'offwhite': '#f3f2ee'
  };

  window.resolveColorName = function (name) {
    if (!name) return '';
    var key = String(name).toLowerCase().trim();
    return COLOR_MAP[key] || key;
  };
})();
